<template>
    <!-- Service announcement banner, shown above the home page content (programs or splash page) -->
    <div v-if="banner && banner.enabled && banner.text"
         class="w-full bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 px-6 py-4 mb-4"
         role="alert">
        <div class="flex items-start gap-3">
            <span class="text-xl mt-0.5">⚠️</span>
            <div v-html="banner.text" class="announcement-banner-content"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AnnouncementBanner',
        props: {
            banner: {
                type: Object,
                default: () => null,
            },
        },
    };
</script>
